import { combineReducers } from 'redux';
import clientApp from './ClientApp/reducers';
import partnerSite from './PartnerSite/reducer';
import { fbeIntegration } from './FacebookBusinessExtension/reducer';
import { automatedMessaging } from './AutomatedMessaging/reducer';

export default combineReducers({
  clientApp,
  partnerSite,
  fbeIntegration,
  automatedMessaging,
});
